module.exports = __webpack_public_path__ + "static/media/400130_02.08e27a1b.png";